import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-column gap-3" }
const _hoisted_2 = { class: "flex align-items-center gap-2" }
const _hoisted_3 = {
  key: 0,
  class: "text-sm text-600"
}
const _hoisted_4 = { class: "flex flex-column gap-2" }
const _hoisted_5 = { class: "flex align-items-center gap-2" }
const _hoisted_6 = { class: "text-600" }
const _hoisted_7 = { class: "flex align-items-center gap-2" }
const _hoisted_8 = { class: "text-600" }
const _hoisted_9 = {
  key: 0,
  class: "border-round p-3 bg-red-50 text-red-700 flex align-items-start gap-2"
}
const _hoisted_10 = {
  key: 1,
  class: "border-round p-3 bg-yellow-50 text-yellow-800 flex align-items-start gap-2"
}

import {
  formatDateBR,
  getMensagemDiasRestantes,
  getStatusPrazoConfig,
  isPrazoExpirado,
  type StatusPrazoConfig,
} from '@/utils/statusPrazoUtils';
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import Tag from 'primevue/tag';
import { computed } from 'vue';

interface Props {
  visible: boolean;
  titulo?: string;
  dataInicio?: string | null;
  dataFim?: string | null;
  statusPrazo?: string | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PeriodoDialog',
  props: {
    visible: { type: Boolean },
    titulo: { default: 'Período do TCC' },
    dataInicio: { default: null },
    dataFim: { default: null },
    statusPrazo: { default: null }
  },
  emits: ["update:visible"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const dialogVisible = computed({
  get: () => props.visible,
  set: (value) => emit('update:visible', value),
});

const statusConfig = computed<StatusPrazoConfig>(() => getStatusPrazoConfig(props.statusPrazo));
const dataInicioFormatada = computed(() => formatDateBR(props.dataInicio));
const dataFimFormatada = computed(() => formatDateBR(props.dataFim));
const mensagemDias = computed(() => getMensagemDiasRestantes(props.dataFim));
const expirado = computed(() => isPrazoExpirado(props.statusPrazo));
const alerta = computed(() => props.statusPrazo === 'alerta');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: dialogVisible.value,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
    header: _ctx.titulo,
    modal: "",
    style: { width: '28rem' },
    closable: true,
    draggable: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(Button), {
        label: "Fechar",
        severity: "secondary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (dialogVisible.value = false))
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(Tag), {
            value: statusConfig.value.label,
            severity: statusConfig.value.severity,
            icon: statusConfig.value.icon
          }, null, 8, ["value", "severity", "icon"]),
          (mensagemDias.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(mensagemDias.value), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("i", { class: "pi pi-calendar text-500" }, null, -1)),
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "font-medium text-700" }, "Início:", -1)),
            _createElementVNode("span", _hoisted_6, _toDisplayString(dataInicioFormatada.value), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[4] || (_cache[4] = _createElementVNode("i", { class: "pi pi-calendar-times text-500" }, null, -1)),
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "font-medium text-700" }, "Prazo final:", -1)),
            _createElementVNode("span", _hoisted_8, _toDisplayString(dataFimFormatada.value), 1)
          ])
        ]),
        (expirado.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[6] || (_cache[6] = [
              _createElementVNode("i", { class: "pi pi-exclamation-circle mt-1" }, null, -1),
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, "Prazo expirado!"),
                _createElementVNode("p", { class: "m-0 mt-1 text-sm" }, " Entre em contato com a coordenação do seu curso para obter mais informações. ")
              ], -1)
            ])))
          : (alerta.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[7] || (_cache[7] = [
                _createElementVNode("i", { class: "pi pi-exclamation-triangle mt-1" }, null, -1),
                _createElementVNode("div", null, [
                  _createElementVNode("strong", null, "Atenção: prazo se aproximando!"),
                  _createElementVNode("p", { class: "m-0 mt-1 text-sm" }, " Restam poucos dias para o encerramento do período. ")
                ], -1)
              ])))
            : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["visible", "header"]))
}
}

})